<template>
<!-- eslint-disable max-len -->
<div class="container">
<div class="row no-gutters">
<div class="login-form col-sm-12">

  <h2>Change Password for</h2>

  <form>
    <div style="margin: 20px;">{{email}}</div>

    <text-input v-model.trim="password" :validator="$v.password" required min-length max-length autofocus>Enter New Password</text-input>

    <button
      type="submit"
      class="btn"
      @click.prevent="onSubmit"
      :disabled="submitted || $v.$invalid">
      <span style="margin: 0 3px;">Confirm New Password</span>
    </button>
  </form>
</div>
</div>
</div>
</template>

<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import { mapActions, mapGetters } from 'vuex';

import TextInput from '@/components/ui/inputs/TextInput';

export default {
  components: {
    TextInput
  },
  data() {
    return {
      password: '',
      submitted: false
    };
  },
  computed: {
    ...mapGetters([
      'me'
    ]),
    email() {
      return this.me.email;
    }
  },
  methods: {
    ...mapActions([
      'getUser',
      'updateMyPassword',
      'flashSuccess',
      'flashDanger'
    ]),
    async onSubmit() {
      if (this.submitted) return;
      this.submitted = true;

      try {
        const { password } = this;
        await this.updateMyPassword({ password });

        const message = 'User password updated successfully';
        this.flashSuccess({ message });
        this.$router.push('/user/edit');
      } catch (_) {
        const message = 'Error updating User password, please try again';
        this.flashDanger({ message });
        this.submitted = false;
      }
    }
  },
  validations: {
    password: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(128)
    }
  }
};
</script>

<style lang="scss" scoped>
.login-form {
  background-color: white;
  margin-top: 50px;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/EditAccountPassword.vue